import React, { useState, useEffect } from 'react';
import { Search as SearchInput, Button, Modal, Typography } from '@telus-uds/components-web';
import queryString from 'query-string';
import moment from 'moment';
import FileDownload from 'js-file-download';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { TableBottomBar } from './css';
import request, { apiHost, config as axiosConfig, isSmReadOnly } from '../../utils/request';
import FMFilters from '../../filters/fmFilters';
import { ContentWrapper, Box } from '../../design/css';
import Table from '../../design/shared/table';
import { OrderListModel } from './models';
import { Search } from '../srtDashboard/css';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import ValidateLoader from '../../UI/validateLoader';
import 'react-responsive-modal/styles.css';
import { getButton, getStatus, getStatusFiltersPayload } from './utils';
import MessageNotification from '../../messageNotification';
import stringInterpolation from '../../utils/stringInterpolation';
import { useLocaleContext } from '../../context/LocaleContext';
import View from './components/view';
import { getOptions, ChannelModel } from '../../orders/models';
import { cybersecurityForm, orderStatus } from '../../utils/constant';
import { getFormattedDate } from '../../utils/utils';
import { ExportOrdersModal } from '../dashboardCommon';

const initialFilterState = {
  startDate: null,
  endDate: null,
  completedStartDate: null,
  completedEndDate: null,
  province: [],
  channelId: [],
  productId: [],
  status: [],
  submitter: []
};

const OrderFulfillmentDashboardCS = ({ location: { search } }) => {
  let url = '';
  const local = useLocaleContext();
  const {
    cybersecurity: {
      dashboard: {
        staticLabelsForFilters,
        CSLandingPage: { searchLabel, searchHint },
        confirmationDialog,
        noOrders,
        loadingMessage,
        confirm,
        cancel,
        proceedWithOrder,
        locked,
        continueLabel,
        continueAction,
        cancelAction,
        confirmationMessage,
        manage,
        successActionMessage,
        status,
        statuses,
        products,
        header
      }
    }
  } = local === 'en-US' ? EN : FR;

  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const { provinces, role } = userProfile;
  const { name } = role;

  const history = useHistory();
  const { q } = queryString.parse(history.location.search);
  const [searchString, setSearchString] = useState(q);
  const [filterState, setFilterState] = useState(initialFilterState);
  const [filters, setFilters] = useState('');
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState({});
  const [data, setData] = useState();
  const [action, setAction] = useState();
  const [channels, setChannels] = useState(null);
  const [submitters, setSubmitters] = useState(null);
  const [isOrderUpdated, setOrderUpdated] = useState();
  const [message, setMessage] = useState('has been successfully updated');
  const [exportingOrders, setExportingOrders] = useState(false);
  const [isExportPopupVisible, setExportPopupVisible] = useState(false);

  const OrderFulfillmentPage = localStorage.getItem('OrderFulfillmentPageCS')
    ? localStorage.getItem('OrderFulfillmentPageCS')
    : 1;

  const [orderFulfillmentPage, setOrderFulfillmentPage] = useState(
    OrderFulfillmentPage
  );

  const [tableHeaders, setTableHeaders] = useState(header);

  const { page } = queryString.parse(search);
  const pageSize = 50;

  const filterData = {
    statuses,
    provinces,
    products,
    channels,
    submitters
  };

  useEffect(() => {
    setTableHeaders(header);
  }, [local]);

  const updateFilters = (key, value) => {
    setFilterState({ ...filterState, [key]: value });
  };

  const resetFilters = () => {
    setOrderFulfillmentPage(1);
    setFilterState({
      ...initialFilterState
    });
    setFilters('');
    filterOrders(true);
  };

  const hideExportPopup = () => {
    setExportPopupVisible(false);
  };

  const onExportOrders = type => {
    setExportingOrders(true);
    const endDate = moment(new Date()).format('YYYY-MM-DD');
    const startDate = moment(new Date())
      .subtract(3, 'month')
      .format('YYYY-MM-DD');
    let exportPayload = {
      filterCriteria: 'createdAt',
      startDate: startDate,
      endDate: endDate
    };
    if (type !== 'all') {
      const payload = getFilterPayload();
      exportPayload = { ...getFilterParams(payload) };
    }

    const exportUrl = `${apiHost}/orders/export/excel?typeOfOrder=CS&`;
    axios
      .post(
        exportUrl,
        { ...exportPayload },
        { responseType: 'arraybuffer', ...axiosConfig() }
      )
      .then(response => response.data)
      .then(fileData => {
        console.log(fileData)
        FileDownload(fileData, 'CS_Orders.xlsx');
        setExportingOrders(false);
      })
      .catch(() => {});
  };

  const showExportPopup = () => {
    setExportPopupVisible(true);
  };

  const fetchOrders = () => {
    return request.get(
      `/orders?typeOfOrder=CS&pageNumber=${orderFulfillmentPage ||
        1}&pageSize=${pageSize}&${url}`
    );
  };
  const fetchData = () => {
    setLoading(true);
    fetchOrders().then(ordersResp => {
      const {
        data: { totalCount: ordersCount, results: orders }
      } = ordersResp;
      setData({
        orders,
        count: ordersCount
      });
      setLoading(false);
    });
  };

  const fetchFiltersData = async () => {
    return axios
      .get(`${apiHost}/get-wln-filters?${url}`, axiosConfig())
      .then(response => {
        setSubmitters(_.get(response, 'data.usersList', 0));
        setChannels(
          getOptions(_.get(response, 'data.channels', 0), ChannelModel)
        );
      })
      .catch();
  };

  const getRedirectUrl = (row, formName) => {
    let steps;
    if (row.status === orderStatus.SendBacktoAccountManager || row.status === orderStatus.submitted) {
      steps = 1;
    } else {
      steps = row.step;
    }
    history.push({
      pathname: `/${row.locale}/${row.categoryName}/${formName}`,
      search: `?orderId=${row.id}&step=${steps}&isEditing=true`
    });
    window.location.reload();
  };

  const getFilterPayload = () => {
    const payload = {
      ...filterState,
      submittedBy:
        filterState.submitter.length && filterState.submitter[0].value,
      province: filterState.province.map(row => row.value),
      channelId: filterState.channelId.map(row => row.value)
    };

    if (filterState.startDate)
      payload.startDate = getFormattedDate(filterState.startDate);
    if (filterState.endDate)
      payload.endDate = getFormattedDate(filterState.endDate);
    if (filterState.completedStartDate)
      payload.completedStartDate = getFormattedDate(
        filterState.completedStartDate
      );
    if (filterState.completedEndDate)
      payload.completedEndDate = getFormattedDate(
        filterState.completedEndDate
      );
    return payload;
  };

  const getFilterParams = payload => {
    let allFilterParamsArray = {};
    if (payload.province && payload.province.length) {
      allFilterParamsArray.province = payload.province.map((n, index) => n);
    }
    if (payload.channelId && payload.channelId.length) {
      allFilterParamsArray.channelId = payload.channelId.map((n, index) => n);
    }
    if (payload.productId && payload.productId.length) {
      allFilterParamsArray.product = payload.productId.flatMap(
        (n, index) => n.value
      );
    }
    if (payload.status && payload.status.length) {
      const { status } = getStatusFiltersPayload(payload.status);
      if (status.length) allFilterParamsArray.status = status;
    }
    if (payload.channelOrgCode && payload.channelOrgCode.length) {
      allFilterParamsArray.channelOrgCode = payload.channelOrgCode.map(
        (n, index) => n.value
      );
    }
    if (payload.startDate) {
      allFilterParamsArray.startDate = payload.startDate;
    }
    if (payload.endDate) {
      allFilterParamsArray.endDate = payload.endDate;
    }
    if (payload.completedStartDate) {
      allFilterParamsArray.completedStartDate = payload.completedStartDate;
    }
    if (payload.completedEndDate) {
      allFilterParamsArray.completedEndDate = payload.completedEndDate;
    }
    if (payload.startDate || payload.endDate) {
      allFilterParamsArray.filterCriteria = 'createdAt';
    }
    if (payload.submitter && payload.submitter.length) {
      allFilterParamsArray.submitter = payload.submitter.map(
        (n, index) => n.value
      );
    }
    return allFilterParamsArray;
  };

  const filterOrders = (isResetMode = false) => {
    if (isResetMode === true) {
      fetchData();
    } else {
      const payload = getFilterPayload();
      setLoading(true);
      const allFilterParamsArray = getFilterParams(payload);
      setFilters(allFilterParamsArray);
      axios
        .post(
          `${apiHost}/orders/filter?typeOfOrder=CS&pageNumber=${orderFulfillmentPage}&pageSize=${pageSize}&${url}`,
          { ...allFilterParamsArray },
          { ...axiosConfig() }
        )
        .then(response => {
          const {
            data: { totalCount: ordersCount, results: orders }
          } = response;
          setData({
            orders,
            count: ordersCount
          });
          setLoading(false);
        })
        .catch(() => {});
    }
  };

  const applyFilters = () => {
    setOrderFulfillmentPage(1);
    localStorage.setItem('OrderFulfillmentPageCS', 1);
    filterOrders();
  };

  const cancelOrder = () => {
    request
      .put(`/orders/${order.id}`, { status: 'ORDER_CANCELED' })
      .then(() => {
        setOrder({ ...order, open: false, isUpdated: true });
        fetchData();
      });
  };

  const onSave = value => {
    setMessage('has been successfully updated');
    window.scrollTo(0, 0);
    setOrderUpdated(value);
  };

  const actionContinue = row => {
    setAction(continueAction);
    setOrder({ open: true, orderDetails: row });
  };

  const actionCancel = (id, orderId) => {
    setAction(cancelAction);
    setOrder({ open: true, id, orderId });
  };

  const actionProceed = row => {
    setAction(proceedWithOrder);
    setOrder({ open: true, orderDetails: row });
  };

  const onConfirm = () => {
    switch (action) {
      case continueAction:
        getRedirectUrl(order.orderDetails, cybersecurityForm);
        break;
      case cancelAction:
        cancelOrder();
        break;
      default:
    }
  };
  const getActions = row => {
    const { status: orderStatus } = row;
    const finalStatus = getStatus(orderStatus);

    const incompleteStatus = finalStatus === status.orderIncomplete;
    const pendingValidation = finalStatus === status.pendingValidation;
    const contractSent = finalStatus === status.contractSent;
    const contractSigned = finalStatus === status.contractSigned;
    const orderCompleted = finalStatus === status.orderCompleted;
    const canceledStatus = finalStatus === status.orderCanceled;
    const sendBacktoAccountManager =
      finalStatus === status.sendBacktoAccountManager;

    let actions;
    const orderData = row;
    const smReadOnly = isSmReadOnly();
    if (incompleteStatus) {
      actions = (
        <>
          {name === 'SALES_SUPPORT' && <View orderData={orderData} onSave={onSave} fetchData={fetchData} role={name} />}
          {!smReadOnly && getButton(() => actionContinue(row), name === 'SALES_SUPPORT' ? "View Details" : continueLabel)}
          {!smReadOnly && name !== 'SALES_SUPPORT' && getButton(() => actionCancel(row.id, row.orderId), cancel)}
        </>
      );
    } else if (pendingValidation) {
      actions = (
        <>
          <View orderData={orderData} onSave={onSave} fetchData={fetchData} role={name}/>
          {!smReadOnly && name === 'SALES_SUPPORT' && getButton(() => actionContinue(row), "View Details")}
          {!smReadOnly && name !== 'SALES_SUPPORT' && getButton(() => actionCancel(row.id, row.orderId), cancel)}
        </>
      );
    } else if (sendBacktoAccountManager) {
      actions = (
        <>
          {name === 'SALES_SUPPORT' && <View orderData={orderData} onSave={onSave} fetchData={fetchData} role={name} />}
          {!smReadOnly && getButton(() => actionContinue(row), name === 'SALES_SUPPORT' ? "View Details" : continueLabel)}
          {!smReadOnly && name !== 'SALES_SUPPORT' && getButton(() => actionCancel(row.id, row.orderId), cancel)}
        </>
      );
    } else if (contractSigned || orderCompleted || contractSent) {
      const orderData = row;
      actions = (
        <>
          <View orderData={orderData} onSave={onSave} fetchData={fetchData} role={name} />
          {!smReadOnly && name === 'SALES_SUPPORT' && getButton(() => actionContinue(row), "View Details")}
        </>
      );
    } else if (canceledStatus) {
      actions = <>
        {name !== 'SALES_SUPPORT' && getButton(() => actionProceed(row), locked, true)}
        {name === 'SALES_SUPPORT' && <View orderData={orderData} onSave={onSave} fetchData={fetchData} role={name} />}
        {!smReadOnly && name === 'SALES_SUPPORT' && getButton(() => actionContinue(row), "View Details")}
      </>;
    }
    return actions;
  };
  const onSearchClick = () => {
    setOrderFulfillmentPage(1);
    localStorage.setItem('OrderFulfillmentPageCS', 1);
    history.push({
      search: `?q=${searchString}`
    });
    if (searchString) {
      url = `q=${searchString}`;
      fetchData();
    } else if (filters) {
      filterOrders();
    } else {
      fetchData();
    }
  };

  const onClear = () => {
    setOrderFulfillmentPage(1);
    localStorage.setItem('OrderFulfillmentPageCS', 1);
    setSearchString('');
    history.push({
      search: ''
    });
    url = filters;
    if (filters) {
      filterOrders();
    } else {
      fetchData();
    }
  };

  useEffect(() => {
    (async () => {
      await fetchFiltersData();
    })();
    if (searchString) {
      url = `q=${searchString}`;
    } else {
      url = filters; // findAll=0 (for MY Orders) & findAll=1 (for All Orders)
    }
  }, []);

  // Search fetch only fires on submit/clear (see onSearchClick/onClear), not on every keystroke
  useEffect(() => {
    if (searchString) {
      url = `q=${searchString}`;
      fetchData();
    } else if (filters) {
      filterOrders();
    } else {
      fetchData();
    }
  }, [page, orderFulfillmentPage]);
  return (
    <>
      <div style={{ padding: '0 6rem' }}>
        <FMFilters
          updateFilters={(key, value) => updateFilters(key, value)}
          filterState={filterState}
          onApplyFilters={applyFilters}
          onResetFilters={resetFilters}
          data={filterData}
          staticLabels={staticLabelsForFilters}
        />
        <Search>
          <div></div>
          <div style={{ marginLeft: 20 }}>
            <SearchInput
              placeholder={searchHint || searchLabel}
              value={searchString || ''}
              onClear={() => onClear()}
              onChange={setSearchString}
              onSubmit={() => onSearchClick()}
            />
          </div>
        </Search>
      </div>
      {isOrderUpdated && isOrderUpdated.isUpdated && (
        <Box top={4} bottom={4}>
          <MessageNotification
            variant={{ validation: 'success' }}
            message={`${'Order with Order ID:'}${
              isOrderUpdated.orderId
            } ${message}`}
          />
        </Box>
      )}
      <ContentWrapper>
        {loading ? (
          <ValidateLoader message={loadingMessage} />
        ) : (
          <>
            {order && order.isUpdated && (
              <Box top={4} bottom={4}>
                <MessageNotification
                  variant={{ validation: 'success' }}
                  message={stringInterpolation(
                    successActionMessage,
                    action,
                    order.orderId
                  )}
                />
              </Box>
            )}
            {data && data.orders && data.orders.length ? (
              <>
                <Table
                  style={{ backgroundColor: 'lime', color: 'black' }}
                  title={manage}
                  header={tableHeaders}
                  data={data.orders}
                  actions={getActions}
                  dataModel={OrderListModel}
                  currentPage={parseInt(orderFulfillmentPage || 1, 10)}
                  setOrderFulfillmentPage={setOrderFulfillmentPage}
                  count={data.count}
                  actionsDisplay="grid"
                  step={pageSize}
                />
              </>
            ) : (
              <div style={{ textAlign: 'center' }}><Typography block>{noOrders}</Typography></div>
            )}
            <TableBottomBar>
              <Button onClick={showExportPopup}>Export Orders</Button>
            </TableBottomBar>
          </>
        )}

        {
          <Modal
            heading={confirmationDialog}
            bodyText={`${confirmationMessage} ${action} ?`}
            confirmButtonText={confirm}
            cancelButtonText={cancel}
            onConfirm={() => onConfirm()}
            onClose={() => setOrder({ ...order, open: false })}
            isOpen={action && order.open}
          />
        }
      </ContentWrapper>
      <ExportOrdersModal
        isLoading={exportingOrders}
        onExportOrders={onExportOrders}
        isVisible={isExportPopupVisible}
        onClose={hideExportPopup}
      />
    </>
  );
};

OrderFulfillmentDashboardCS.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

export default OrderFulfillmentDashboardCS;
